import React, { Fragment, useEffect, useState, useRef } from "react";
import "./myAssessment.scss";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { ProgressBar, Table } from "react-bootstrap";
import { Accordion, Card, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDetailedReport,
  getDetailedOldReport,
  updatedScore,
  getProctotingAnalysis,
  updateCandidateScore,
  addCandidateTestComment,
} from "../../Redux/ActionCreators/reportAction";
import { useSelector } from "react-redux";
import {
  formatAMPM,
  getMbtiResult,
} from "../../utils/miscelleneous";
import Lightbox from "../../utils/lightbox";
import UpArrow from "../../assets/up-accordion.svg";
import DownArrow from "../../assets/down-accordion.svg";
import { Dialog, Snackbar, Alert, CircularProgress } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import html2pdf from "html2pdf.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { formatUTCToUserTimezone } from "../../utils/miscelleneous";

const progressStyle = {
  // width: ${progress}%,
  width: "100%",
  backgroundColor: "Green",
  height: "10px",
  borderRadius: "5px",
  BorderColor: "",
  backgroundImage: "linear-gradient(to right, #5edc82, #14b4c7)",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.6)",
  MarginOutlined: "Bold",
};

export default function TestReport(props) {
  const [activeKey, setActiveKey] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [active, setActive] = useState(0);
  const [openBox, setOpenBox] = useState(false);
  const [image, setImage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const reportRef = useRef(null);
  const proctoringFetchedRef = useRef(false);
  const testChatRef = useRef(null);
  const routeState = location.state;
  const [loading, setLoading] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [proctoringLoading, setProctoringLoading] = useState(false);
  const [proctoringFetched, setProctoringFetched] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [editScore, setEditScore] = useState("");
  const [editComment, setEditComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [commentPopup, setCommentPopup] = useState(false);
  const [commentsData, setCommentsData] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [testCommentPopup, setTestCommentPopup] = useState(false);
  const [testComments, setTestComments] = useState([]);
  const [newCommentText, setNewCommentText] = useState("");
  const [sendingComment, setSendingComment] = useState(false);
  const [showAllImages, setShowAllImages] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isLargePDF, setIsLargePDF] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const isMobile = window.innerWidth < 767;
  const propsState = props?.overrideState;
  const state = propsState || routeState;
  const isInline = propsState !== undefined;
  const isSharedReport = props?.isSharedReport === true;

  const [score, setScore] = useState("");
  const { detailReport } = useSelector((state) => state.myAssessment);
  const { proctoringReport } = useSelector((state) => state.report);
  const testDateTime = formatUTCToUserTimezone(detailReport?.testAttemptDate);

  const hideSensitive = detailReport?.statusId === 4 ? true : false;

  const fetchReport = async () => {
    setLoading(true);
    if (state.type === "new") {
      await dispatch(getDetailedReport(state.id));
    } else {
      await dispatch(getDetailedOldReport(state.id));
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchReport();
  }, [state.id, state.type, dispatch]);

  useEffect(() => {
    const test = detailReport?.tests?.[0];

    const candidateTestId =
      test?.questions?.[0]?.candidateTestId ||
      test?.codingQuestions?.[0]?.candidateTestId ||
      test?.databaseQuestions?.[0]?.candidateTestId ||
      detailReport?.candidateTestId;

    const fetchProctoring = async () => {
      if (candidateTestId && !proctoringFetchedRef.current) {
        proctoringFetchedRef.current = true;
        await setProctoringLoading(true);
        const res = await dispatch(getProctotingAnalysis(candidateTestId));
        if (res.status === 200) {
          setProctoringLoading(false);
        }
        setProctoringFetched(true);
      }
    };

    fetchProctoring();
  }, [detailReport, dispatch, proctoringFetched]);

  useEffect(() => {
    const bootstrap = window.bootstrap;
    if (!bootstrap) return;

    const timeout = setTimeout(() => {
      const tooltipTriggerList = Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.forEach((el) => new bootstrap.Tooltip(el));
    }, 300);

    return () => clearTimeout(timeout);
  }, [detailReport?.capturedImages]);

  useEffect(() => {
    if (testChatRef.current) {
      testChatRef.current.scrollTop = testChatRef.current.scrollHeight;
    }
  }, [testComments]);

  const goBack = () => {
    navigate(-1);
  };

  const handleAccordionClick = (index) => {
    if (activeKey === index) {
      setActiveKey(null); // Close if clicking on the already open accordion
    } else {
      setActiveKey(index); // Open the clicked accordion
    }
  };

  const handleLanguageAccordionClick = (key) => {
    setActiveAccordion((prev) => (prev === key ? null : key));
  };

  const accordionIcon = (index) => {
    if (activeKey === index) {
      return <img src={UpArrow} style={{ float: "right" }} alt="" />;
    } else {
      return <img src={DownArrow} alt="" style={{ float: "right" }} />;
    }
  };

  const updateScore = async (el) => {
    setLoadingReport(true);
    let obj = {
      candidateTestId: el.candidateTestId,
      candidateTestQuestionId: el.candidateTestQuestionId,
      score: score,
    };
    await dispatch(updatedScore(obj));
    await dispatch(getDetailedReport(location.state.id));
    setLoadingReport(false);
  };

  const handleSaveEdit = async () => {
    if (!selectedQuestion) return;

    const maxScore = selectedQuestion?.score || 0;
    const newScore = Number(editScore);

    if (isNaN(newScore) || newScore < 0 || newScore > maxScore) {
      setSnackbar({
        open: true,
        message: `Score must be between 0 and ${maxScore}`,
      });
      return;
    }

    setSaving(true);

    const payload = {
      candidateTestId: selectedQuestion.candidateTestId,
      candidateTestQuestionId: selectedQuestion.candidateQuestionId,
      isAnswered: true,
      score: Number(editScore),
      comment: editComment,
    };

    try {
      const res = await dispatch(updateCandidateScore(payload));
      if (res.success) {
        await dispatch(getDetailedReport(location.state.id));
        setShowEditPopup(false);
        setEditScore("");
        setEditComment("");
      }
    } finally {
      setSaving(false);
    }
  };

  const excludedTestNames = [
    "Gappeo 4D Personality Test",
    "Gappeo 6-Facet Personality Test",
  ];
  const testNames = detailReport?.tests?.map((test) => test.testName) || [];

  const hasOnlyExcludedTestNames = testNames.every((name) =>
    excludedTestNames.includes(name)
  );
  const hasMixedTestNames = testNames.some(
    (name) => !excludedTestNames.includes(name)
  );

  const hideQuestionBodyInPDF =
    document.body.classList.contains("pdf-export") &&
    detailReport?.tests?.length > 5;

  const downloadPDF = () => {
    document.body.classList.add("pdf-export");
    setActiveKey("all");

    requestAnimationFrame(() => {
      const element = reportRef.current;
      if (!element) return;

      const height = element.scrollHeight;

      const large = height > 75000;

      setIsLargePDF(large);

      requestAnimationFrame(() => {
        let scale = 1;
        if (height > 30000) scale = 1;

        const opt = {
          margin: [10, 5, 10, 5],
          filename: `${detailReport?.testName}-${detailReport?.name}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale,
            useCORS: true,
            allowTaint: true,
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          pagebreak: { mode: ["css", "legacy"] },
        };

        html2pdf()
          .set(opt)
          .from(element)
          .save()
          .finally(() => {
            document.body.classList.remove("pdf-export");
            setActiveKey(null);
            setIsLargePDF(false);
            fetchReport();
          });
      });
    });
  };

  const downloadFile = (url, filename) => {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
  };

  const renderFullTestBlock = (test, index, isPDF = false) => {
    if (!test) return <p>No data available</p>;

    let languageResult = null;
    let isLanguageResultPending = false;

    if (test.referenceTypeId === 7) {
      if (!test.result || test.result.trim() === "") {
        isLanguageResultPending = true;
      } else {
        try {
          const parsed = JSON.parse(test.result);
          languageResult = parsed?.Data || null;

          if (!languageResult) {
            isLanguageResultPending = true;
          }
        } catch (e) {
          isLanguageResultPending = true;
        }
      }
    }

    const getListeningAudioUrl = (question) => {
      return (
        question?.Content?.audio_url ||
        question?.Content?.AudioUrl ||
        question?.AudioUrl ||
        null
      );
    };

    return (
      <div style={{ marginBottom: "30px" }}>
        {/* ================= SUMMARY BLOCK ================= */}

        {/* MCQ summary */}
        {test.referenceTypeId === 1 &&
          ![7, 8].includes(test.testType) &&
          test.topics?.length > 0 && (
            <>
              <div style={{ pageBreakInside: "avoid" }}>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Topic level scores</th>
                      <th>Topic Average - {test.score}%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {test.topics.map((topic, idx) => (
                      <tr key={idx}>
                        <td>{topic.skillTopicName}</td>
                        <td>{topic.score}%</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {(test.easyLevelScore ||
                test.mediumLevelScore ||
                test.hardLevelScore) && (
                  <div style={{ pageBreakInside: "avoid" }}>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Difficulty level scores</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Easy - {test.easyLevelScore || 0}%</td>
                        </tr>
                        <tr>
                          <td>Medium - {test.mediumLevelScore || 0}%</td>
                        </tr>
                        <tr>
                          <td>Hard - {test.hardLevelScore || 0}%</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}
            </>
          )}

        {/* Test-level comments */}
        {index === 0 &&
          (() => {
            const currentTestComments =
              testComments?.length > 0 ? testComments : test.comments;

            return (
              currentTestComments &&
              currentTestComments.length > 0 && (
                <div style={{ marginTop: 12, pageBreakInside: "avoid" }}>
                  <h4 style={{ marginBottom: 8 }}>Test Comments</h4>

                  <div
                    style={{
                      background: "#F8F9FA",
                      padding: 15,
                      borderRadius: 10,
                      border: "1px solid #E0E0E0",
                    }}
                  >
                    {currentTestComments.map((c, i) => (
                      <div key={i} style={{ marginBottom: 12 }}>
                        <div style={{ fontWeight: 600, color: "#333" }}>
                          {c.createdByName?.trim()}
                        </div>

                        <div
                          style={{
                            marginTop: 6,
                            fontSize: 14,
                            lineHeight: 1.4,
                          }}
                        >
                          {c.commentText}
                        </div>

                        <div
                          style={{ fontSize: 11, color: "#777", marginTop: 4 }}
                        >
                          {new Date(c.createdAt).toLocaleString()}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            );
          })()}

        {/* Personality summary */}
        {test.referenceTypeId === 4 && test.personalityTopics?.length > 0 && (
          <div>
            {test.personalityTopics.map((p, i) => (
              <div
                key={i}
                className="personality"
                style={{ marginBottom: "15px", pageBreakInside: "avoid" }}
              >
                <h4>
                  {p.topic} - {p.percentage}%
                </h4>
                <p>
                  <strong>Description:</strong> {p.topicDescription}
                </p>
                <hr />
              </div>
            ))}
          </div>
        )}

        {/* MBTI summary */}
        {test.referenceTypeId === 5 && test.mbtiTestResult && (
          <div>
            {getMbtiResult(test.mbtiTestResult).map((p, idx) => (
              <div
                key={idx}
                className="mbti-summary"
                style={{ marginBottom: "15px", pageBreakInside: "avoid" }}
              >
                <p>
                  <strong>Type:</strong> {p.type}
                </p>
                <p>
                  <strong>Nick Name:</strong> {p.nickname}
                </p>
                <p>
                  <strong>Description:</strong> {p.description}
                </p>
                <hr />
              </div>
            ))}
          </div>
        )}

        {/* Coding summary */}
        {test.referenceTypeId === 3 && test.codingQuestions?.length > 0 && (
          <div style={{ marginTop: 20 }}>
            {(test.codingQuestions || test.databaseQuestions).map((q, i) => (
              <div
                key={i}
                style={{
                  marginBottom: "25px",
                  pageBreakInside: "avoid",
                }}
              >
                <div
                  style={{
                    padding: "18px",
                    borderRadius: 12,
                    background: "#FAFAFA",
                    border: "1px solid #E6E6E6",
                  }}
                >
                  <h4
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    {q.question}
                  </h4>

                  <p style={{ fontSize: 14, margin: 0 }}>
                    <strong>Problem Statement:</strong>
                  </p>
                  <div
                    style={{
                      background: "#FFF",
                      padding: "12px 14px",
                      borderRadius: 8,
                      marginTop: 8,
                      border: "1px solid #EEE",
                    }}
                    dangerouslySetInnerHTML={{ __html: q.description }}
                  />

                  <p
                    style={{
                      marginTop: 12,
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#444",
                    }}
                  >
                    Score: {q.candidateScore} / {q.score}
                  </p>

                  {/* === Question Comments === */}
                  {q.comments?.length > 0 && (
                    <div
                      style={{
                        marginTop: 12,
                        background: "#FFF",
                        padding: 12,
                        borderRadius: 8,
                        border: "1px solid #EEE",
                      }}
                    >
                      <h5 style={{ margin: 0, marginBottom: 8 }}>
                        Question Comments
                      </h5>

                      {q.comments.map((c, idx) => (
                        <div key={idx} style={{ marginBottom: 12 }}>
                          <div style={{ fontWeight: 600, color: "#075E54" }}>
                            {c.createdByName?.trim()}
                          </div>

                          <div style={{ marginTop: 4 }}>{c.commentText}</div>

                          <div
                            style={{ fontSize: 11, color: "#666", marginTop: 4 }}
                          >
                            {new Date(c.createdAt).toLocaleString()}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Final code submitted (DB only) */}
                  {q.finalCodeSubmitted && (
                    <div style={{ marginTop: 14 }}>
                      <p style={{ fontSize: 14, fontWeight: 600 }}>
                        Final Code Submitted
                      </p>
                      <div
                        style={{
                          background: "#FFF",
                          padding: 10,
                          borderRadius: 8,
                          border: "1px solid #EEE",
                        }}
                        dangerouslySetInnerHTML={{ __html: q.finalCodeSubmitted }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {test.referenceTypeId === 1 &&
          (test.testType === 7 || test.testType === 8) &&
          test.codingQuestions?.length > 0 && (
            <div style={{ marginTop: 20 }}>
              {(test.codingQuestions || test.databaseQuestions).map((q, i) => (
                <div
                  key={i}
                  style={{
                    marginBottom: "25px",
                    pageBreakInside: "avoid",
                  }}
                >
                  <div
                    style={{
                      padding: "18px",
                      borderRadius: 12,
                      background: "#FAFAFA",
                      border: "1px solid #E6E6E6",
                    }}
                  >
                    <h4
                      style={{
                        fontSize: 18,
                        fontWeight: 600,
                        marginBottom: 8,
                        color: "#333",
                      }}
                    >
                      {q.question}
                    </h4>

                    <p style={{ fontSize: 14, margin: 0 }}>
                      <strong>Problem Statement:</strong>
                    </p>
                    <div
                      style={{
                        background: "#FFF",
                        padding: "12px 14px",
                        borderRadius: 8,
                        marginTop: 8,
                        border: "1px solid #EEE",
                      }}
                      dangerouslySetInnerHTML={{ __html: q.description }}
                    />

                    <p
                      style={{
                        marginTop: 12,
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#444",
                      }}
                    >
                      Score: {q.candidateScore} / {q.score}
                    </p>

                    {/* === Question Comments === */}
                    {q.comments?.length > 0 && (
                      <div
                        style={{
                          marginTop: 12,
                          background: "#FFF",
                          padding: 12,
                          borderRadius: 8,
                          border: "1px solid #EEE",
                        }}
                      >
                        <h5 style={{ margin: 0, marginBottom: 8 }}>
                          Question Comments
                        </h5>

                        {q.comments.map((c, idx) => (
                          <div key={idx} style={{ marginBottom: 12 }}>
                            <div style={{ fontWeight: 600, color: "#075E54" }}>
                              {c.createdByName?.trim()}
                            </div>

                            <div style={{ marginTop: 4 }}>{c.commentText}</div>

                            <div
                              style={{
                                fontSize: 11,
                                color: "#666",
                                marginTop: 4,
                              }}
                            >
                              {new Date(c.createdAt).toLocaleString()}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Final code submitted (DB only) */}
                    {q.finalCodeSubmitted && (
                      <div style={{ marginTop: 14 }}>
                        <p style={{ fontSize: 14, fontWeight: 600 }}>
                          Final Code Submitted
                        </p>
                        <div
                          style={{
                            background: "#FFF",
                            padding: 10,
                            borderRadius: 8,
                            border: "1px solid #EEE",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: q.finalCodeSubmitted,
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

        {test.referenceTypeId === 6 && test.databaseQuestions?.length > 0 && (
          <div style={{ marginTop: 20 }}>
            {(test.codingQuestions || test.databaseQuestions).map((q, i) => (
              <div
                key={i}
                style={{
                  marginBottom: "25px",
                  pageBreakInside: "avoid",
                }}
              >
                <div
                  style={{
                    padding: "18px",
                    borderRadius: 12,
                    background: "#FAFAFA",
                    border: "1px solid #E6E6E6",
                  }}
                >
                  <h4
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    {q.question}
                  </h4>

                  <p style={{ fontSize: 14, margin: 0 }}>
                    <strong>Problem Statement:</strong>
                  </p>
                  <div
                    style={{
                      background: "#FFF",
                      padding: "12px 14px",
                      borderRadius: 8,
                      marginTop: 8,
                      border: "1px solid #EEE",
                    }}
                    dangerouslySetInnerHTML={{ __html: q.description }}
                  />

                  <p
                    style={{
                      marginTop: 12,
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#444",
                    }}
                  >
                    Score: {q.candidateScore} / {q.score}
                  </p>

                  {/* === Question Comments === */}
                  {q.comments?.length > 0 && (
                    <div
                      style={{
                        marginTop: 12,
                        background: "#FFF",
                        padding: 12,
                        borderRadius: 8,
                        border: "1px solid #EEE",
                      }}
                    >
                      <h5 style={{ margin: 0, marginBottom: 8 }}>
                        Question Comments
                      </h5>

                      {q.comments.map((c, idx) => (
                        <div key={idx} style={{ marginBottom: 12 }}>
                          <div style={{ fontWeight: 600, color: "#075E54" }}>
                            {c.createdByName?.trim()}
                          </div>

                          <div style={{ marginTop: 4 }}>{c.commentText}</div>

                          <div
                            style={{ fontSize: 11, color: "#666", marginTop: 4 }}
                          >
                            {new Date(c.createdAt).toLocaleString()}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Final code submitted (DB only) */}
                  {q.finalCodeSubmitted && (
                    <div style={{ marginTop: 14 }}>
                      <p style={{ fontSize: 14, fontWeight: 600 }}>
                        Final Code Submitted
                      </p>
                      <div
                        style={{
                          background: "#FFF",
                          padding: 10,
                          borderRadius: 8,
                          border: "1px solid #EEE",
                        }}
                        dangerouslySetInnerHTML={{ __html: q.finalCodeSubmitted }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {test.referenceTypeId === 7 && (
          <>
            {isLanguageResultPending && (
              <div
                style={{
                  marginTop: 24,
                  padding: "20px",
                  borderRadius: "8px",
                  background: "#F7FAFC",
                  border: "1px solid #E4E9F0",
                }}
              >
                <h5 style={{ marginBottom: 8 }}>
                  Language test evaluation is still in progress
                </h5>
                <p style={{ fontSize: 14, color: "#475569", margin: 0 }}>
                  Please check after some time to view detailed results.
                </p>
              </div>
            )}
            {languageResult && (
              <div style={{ marginTop: 20 }}>
                {/* ================= TOP SUMMARY ================= */}
                <div className="d-flex" style={{ gap: '24px', marginBottom: '40px', overflow: 'auto', }}>
                  <div
                    style={{
                      width: '144px',
                      height: '105px',
                      borderRadius: '8px',
                      padding: '12px',
                      background: '#F7FAFC',
                      border: '1px solid #E4E9F0',
                      textAlign: 'center'
                    }}
                  >
                    {languageResult.Assignment.CefrRating &&
                      <strong
                        style={{
                          height: '40px',
                          fontFamily: '"inter", sans-serif',
                          fontWeight: '700',
                          fontSize: isMobile ? '14' : '18',
                          textAlign: 'center',
                          color: '#313539',
                        }}
                      >{languageResult.Assignment.CefrRating.Level} <br />
                        {languageResult.Assignment.CefrRating.Description}
                      </strong>
                    }
                    <div
                      style={{
                        height: '40px',
                        fontFamily: '"inter", sans-serif',
                        fontWeight: '400',
                        fontSize: '14px',
                        lineHeight: '20px',
                        textAlign: 'center',
                        color: '#313539',
                      }}
                    >
                      Level
                    </div>
                  </div>

                  <div
                    style={{
                      width: '144px',
                      height: '100px',
                      borderRadius: '8px',
                      padding: '12px',
                      background: '#F7FAFC',
                      border: '1px solid #E4E9F0',
                      textAlign: 'center'
                    }}
                  >
                    <strong
                      style={{
                        height: '40px',
                        fontFamily: '"inter", sans-serif',
                        fontWeight: '700',
                        fontSize: '18px',
                        lineHeight: '40px',
                        textAlign: 'center',
                        color: '#313539',
                      }}
                    >{languageResult.Assignment.Percentage}%</strong>
                    <div
                      style={{
                        height: '40px',
                        fontFamily: '"inter", sans-serif',
                        fontWeight: '400',
                        fontSize: '14px',
                        lineHeight: '20px',
                        textAlign: 'center',
                        color: '#313539',
                      }}
                    >Percentage</div>
                  </div>

                  <div
                    style={{
                      width: '144px',
                      height: '100px',
                      borderRadius: '8px',
                      padding: '12px',
                      background: '#F7FAFC',
                      border: '1px solid #E4E9F0',
                      textAlign: 'center'
                    }}
                  >
                    <strong
                      style={{
                        height: '40px',
                        fontFamily: '"inter", sans-serif',
                        fontWeight: '700',
                        fontSize: '18px',
                        lineHeight: '40px',
                        textAlign: 'center',
                        color: '#313539',
                      }}
                    >{languageResult.Assignment.OverallScore.toFixed(2)}/
                      {languageResult.Assignment.MaxPossibleScore.toFixed(0)}</strong>
                    <div
                      style={{
                        height: '40px',
                        fontFamily: '"inter", sans-serif',
                        fontWeight: '400',
                        fontSize: '14px',
                        lineHeight: '20px',
                        textAlign: 'center',
                        color: '#313539',
                      }}
                    >
                      Overall Score
                    </div>
                  </div>

                </div>

                {/* ================= DETAILED QUESTION ANALYSIS ================= */}
                <h4 style={{ marginBottom: 20 }}>Detailed Question Analysis</h4>

                {languageResult.Sections.map((section, sectionIndex) => (
                  <div key={sectionIndex} style={{ marginBottom: 32, margin: isMobile ? '20px' : '', }}>
                    <h5 style={{ marginBottom: 16 }}>{section.SectionName}</h5>

                    {/* ================= LISTENING SECTION ================= */}
                    {section.SectionName === "Listening Section" &&
                      (() => {
                        const parents = section.Questions.filter(
                          (q) =>
                            q.ParentQuestionId === null &&
                            q.QuestionType === "listening_comprehension_set"
                        );

                        return parents.map((parent, pIdx) => {
                          const children = section.Questions.filter(
                            (q) =>
                              q.ParentQuestionId === parent.AssignmentQuestionId
                          );

                          const audioUrl = getListeningAudioUrl(parent);

                          return (
                            <div key={pIdx} style={{ marginBottom: 32 }}>
                              <p style={{ fontStyle: "italic", marginBottom: 8, paddingLeft: isMobile ? '0' : '', }}>
                                {parent.QuestionText}
                              </p>

                              {audioUrl && (
                                <audio
                                  controls
                                  src={audioUrl}
                                  style={{ width: "100%", marginBottom: 16 }}
                                />
                              )}

                              <strong>Questions based on the audio:</strong>

                              <Accordion activeKey={activeAccordion}>
                                {children.map((q, qIdx) => {
                                  const accordionKey = `listen-${sectionIndex}-${pIdx}-${qIdx}`;

                                  return (
                                    <Card
                                      key={accordionKey}
                                      style={{ marginTop: 12 }}
                                    >
                                      <Card.Header
                                        onClick={() =>
                                          handleLanguageAccordionClick(accordionKey)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span className="accordion-title">
                                            {q.QuestionText}
                                          </span>
                                          <div className="d-flex gap-2">
                                            {q.IsCorrect === true && (
                                              <img
                                                src="/images/green-check.svg"
                                                alt="correct"
                                              />
                                            )}
                                            {q.IsCorrect === false && (
                                              <img
                                                src="/images/close-check-red.svg"
                                                alt="wrong"
                                              />
                                            )}
                                            <img src={activeAccordion === accordionKey ? UpArrow : DownArrow} alt="toggle" />
                                          </div>
                                        </div>
                                      </Card.Header>

                                      <Accordion.Collapse eventKey={accordionKey}>
                                        <Card.Body>
                                          <div className="d-flex justify-content-between mb-2">
                                            <span>
                                              <strong>Type:</strong>{" "}
                                              {q.QuestionType}
                                            </span>
                                            <span>
                                              <strong>Score:</strong> {q.Score} /{" "}
                                              {q.MaxScore}
                                            </span>
                                          </div>

                                          {q.IsCorrect !== null && (
                                            <div
                                              style={{
                                                padding: 12,
                                                borderRadius: 6,
                                                border: q.IsCorrect
                                                  ? "1px solid #2e7d32"
                                                  : "1px solid #e0e0e0",
                                                background: q.IsCorrect
                                                  ? "#e8f5e9"
                                                  : "#f5f5f5",
                                              }}
                                            >
                                              Answer evaluation shown here
                                            </div>
                                          )}
                                        </Card.Body>
                                      </Accordion.Collapse>
                                    </Card>
                                  );
                                })}
                              </Accordion>
                            </div>
                          );
                        });
                      })()}

                    {/* ================= READING & SPEAKING ================= */}
                    {(section.SectionName === "Reading Section" ||
                      section.SectionName === "Speaking Section") && (
                        <Accordion activeKey={activeAccordion}>
                          {section.Questions.map((q, qIdx) => {
                            const accordionKey = `${section.SectionName}-${sectionIndex}-${qIdx}`;

                            return (
                              <Card key={accordionKey} style={{ marginBottom: 16 }}>
                                <Card.Header
                                  onClick={() =>
                                    handleLanguageAccordionClick(accordionKey)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="accordion-title">
                                      {q.QuestionText}
                                    </span>
                                    <div className="d-flex gap-2">
                                      <img src={activeAccordion === accordionKey ? UpArrow : DownArrow} alt="toggle" />
                                    </div>
                                  </div>
                                </Card.Header>

                                <Accordion.Collapse eventKey={accordionKey}>
                                  <Card.Body>
                                    {q.AudioUrl && (
                                      <audio
                                        controls
                                        src={q.AudioUrl}
                                        style={{ width: "100%", marginBottom: 12 }}
                                      />
                                    )}

                                    <div className="d-flex justify-content-between">
                                      <span>
                                        <strong>Type:</strong> {q.QuestionType}
                                      </span>
                                      <span>
                                        <strong>Score:</strong> {q.Score} /{" "}
                                        {q.MaxScore}
                                      </span>
                                    </div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            );
                          })}
                        </Accordion>
                      )}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const renderAllTestsForPDF = () => {
    if (!detailReport?.tests?.length) return null;

    return (
      <div className="pdf-tests">
        {detailReport.tests.map((test, i) => (
          <div key={i} className="pdf-test-block">
            <h4 className="pdf-test-header">{test.testName}</h4>
            <div className="pdf-test-content">
              {renderFullTestBlock(test, i, true)} {/* force expanded */}
            </div>
          </div>
        ))}

        {detailReport?.capturedImages?.length > 0 && (
          <div className="image-lists" style={{ marginTop: "50px" }}>
            <h4>Proctoring analysis</h4>
            {proctoringReport && proctoringReport.candidateTestId && (
              <div
                className="proctoring-report"
                style={{ pageBreakInside: "avoid" }}
              >
                <div className="proctoring-report-item">
                  <div className="proctoring-report-count">
                    <img src="/images/browser-black-icon.svg" alt="" />
                    <h6>{proctoringReport?.browsersUsed}</h6>
                  </div>
                  <p>Browsers used</p>
                </div>
                <div className="proctoring-report-item">
                  <div className="proctoring-report-count">
                    <img src="/images/diamond-turn-right.svg" alt="" />
                    <h6>{proctoringReport?.navigationViolations}</h6>
                  </div>
                  <p>Navigation violations</p>
                </div>
                <div className="proctoring-report-item">
                  <div>
                    <div className="proctoring-report-count">
                      <img src="/images/time-fast.svg" alt="" />
                      <h6>{proctoringReport?.testWindowViolationTime} sec</h6>
                    </div>
                  </div>
                  <p>Test window violations</p>
                </div>
                <div className="proctoring-report-item">
                  <div>
                    <div className="proctoring-report-count">
                      <img src="/images/webcam-icon.svg" alt="" />
                      <h6>{proctoringReport?.webcamViolations}</h6>
                    </div>
                  </div>
                  <p>Webcam violations</p>
                </div>
              </div>
            )}
            <div style={{ display: "block" }}>
              {detailReport?.capturedImages?.map((el, i) => {
                let analysis = {};
                try {
                  analysis = el.analysis ? JSON.parse(el.analysis) : {};
                } catch (err) {
                  console.error("Failed to parse analysis:", err);
                }

                const cheating = analysis?.CheatingDetected === true;
                const summary = analysis?.Summary || "";

                if (
                  document.body.classList.contains("pdf-export") &&
                  isLargePDF &&
                  !cheating
                ) {
                  return null;
                }

                return (
                  <div
                    key={i}
                    style={{
                      width: "48%",
                      display: "inline-block",
                      verticalAlign: "top",
                      marginBottom: "30px",
                      marginRight: i % 2 === 0 ? "2%" : "0",
                      pageBreakInside: "avoid",
                      breakInside: "avoid",
                      WebkitColumnBreakInside: "avoid",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        border: cheating ? "2px solid red" : "1px solid #ccc",
                        borderRadius: "6px",
                        padding: "8px",
                        boxSizing: "border-box",
                        background: "#fff",
                        width: "100%",
                      }}
                    >
                      <div style={{ flex: "0 0 45%", textAlign: "center" }}>
                        <img
                          src={el.imageURL}
                          alt="proctoring"
                          style={{
                            width: "100%",
                            borderRadius: "4px",
                            display: "block",
                            pageBreakInside: "avoid",
                            breakInside: "avoid",
                          }}
                          crossOrigin="anonymous"
                        />
                        <span
                          className="time"
                          style={{
                            display: "block",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {formatAMPM(el.addedDate)}
                        </span>
                      </div>

                      <div
                        style={{
                          flex: "1",
                          paddingLeft: "10px",
                          fontSize: "13px",
                          color: "#333",
                          pageBreakInside: "avoid",
                          breakInside: "avoid",
                        }}
                      >
                        {document.body.classList.contains("pdf-export") &&
                          isLargePDF ? (
                          cheating ? (
                            <p style={{ margin: 0 }}>
                              {summary || "No cheating Detected"}
                            </p>
                          ) : (
                            <p style={{ margin: 0 }}>No analysis available</p>
                          )
                        ) : (
                          <p style={{ margin: 0 }}>
                            {summary || "No cheating Detected"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleViewComments = async (questionObj) => {
    setCommentLoading(true);
    const localComments = questionObj?.comments;
    if (Array.isArray(localComments) && localComments.length > 0) {
      const sorted = [...localComments].sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );
      setCommentsData(sorted);
      setCommentLoading(false);
      setCommentPopup(true);
      return;
    }
    setCommentLoading(false);
    setSnackbar({
      open: true,
      message: "No comments available for this question.",
      severity: "info",
    });
  };

  const openTestComments = () => {
    const commentsArr =
      detailReport?.comments && Array.isArray(detailReport.comments)
        ? [...detailReport.comments].sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        )
        : [];
    setTestComments(commentsArr);
    setTestCommentPopup(true);
  };

  const handleSendTestComment = async () => {
    if (!newCommentText?.trim()) return;
    const candidateTestId = detailReport?.candidateTestId;
    const payload = {
      candidateTestId,
      commentText: newCommentText.trim(),
    };

    setSendingComment(true);
    const res = await dispatch(addCandidateTestComment(payload));
    setSendingComment(false);

    if (res?.success && res?.data) {
      const createdComment = res.data;
      const commentObj = createdComment.commentId
        ? createdComment
        : {
          commentId: createdComment?.id || Math.random(),
          commentText: newCommentText.trim(),
          createdAt: new Date().toISOString(),
          createdBy: createdComment?.createdBy || null,
          createdByName: createdComment?.createdByName || "You",
          createdByEmail: createdComment?.createdByEmail || "",
          commentScope: "TEST",
        };

      const updated = [...testComments, commentObj].sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );
      setTestComments(updated);
      setNewCommentText("");
      setSnackbar({
        open: true,
        message: "Comment added successfully",
        severity: "success",
      });
    } else {
      setSnackbar({
        open: true,
        message: res?.message || "Failed to add comment",
        severity: "error",
      });
    }
  };

  const getProcessedImages = () => {
    const images = detailReport?.capturedImages || [];

    if (showAllImages) return images;
    const firstTwo = images.slice(0, 2);
    const rest = images.slice(2);
    const cheatingImages = rest.filter((img) => {
      try {
        const a = img.analysis ? JSON.parse(img.analysis) : {};
        return a?.CheatingDetected === true;
      } catch {
        return false;
      }
    });

    const normalImages = rest.filter((img) => {
      try {
        const a = img.analysis ? JSON.parse(img.analysis) : {};
        return a?.CheatingDetected !== true;
      } catch {
        return true;
      }
    });

    const finalFive = [
      ...cheatingImages.slice(0, 5),
      ...normalImages.slice(0, Math.max(0, 5 - cheatingImages.length)),
    ];

    return [...firstTwo, ...finalFive];
  };

  const processedImages = getProcessedImages();

  const getFileFromAnswerData = (answerData) => {
    try {
      if (!answerData) return null;
      const parsed = JSON.parse(answerData);
      return parsed?.files?.[0] || null;
    } catch {
      return null;
    }
  };

  return (
    <div className="test-report-holder" ref={reportRef}>
      <Dialog
        className="screen-loader"
        open={loading && proctoringLoading}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        Loading ...
      </Dialog>
      <Dialog
        className="screen-loader"
        open={loadingReport && proctoringLoading}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        Loading Score ...
      </Dialog>
      <Dialog open={commentLoading}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px",
          }}
        >
          <CircularProgress />
        </div>
      </Dialog>

      {loading ? (
        ""
      ) : state.type === "new" ? (
        detailReport !== null ? (
          <Fragment>
            <div className="test-report-header">
              <div className="d-flex justify-content-center">
                <img
                  src="/images/gappeoai-logo.png"
                  alt="Logo"
                  className="pdf-only"
                  style={{
                    width: "260px",
                    height: "56px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {!isInline && (
                  <>
                    <img
                      src="/images/back.svg"
                      className="cursor-pointer exclude-pdf"
                      onClick={() => goBack()}
                      alt=""
                    />
                  </>
                )}
                <h3 style={{ alignItems: "start" }}>Test Report</h3>
                <div className="d-flex align-items-center gap-2">
                  {!isSharedReport && !hideSensitive && (
                    <img
                      className="exclude-pdf"
                      src="/images/comment-icon.svg"
                      alt="Summary"
                      style={{
                        width: "18px",
                        height: "18px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => openTestComments()}
                    />
                  )}
                  {!isSharedReport && (
                    <>
                      {isMobile ?
                        <img className="curser-pointer" src="/images/file-download-icon.svg" alt="" width={24} height={24} onClick={downloadPDF} />
                        :
                        <button
                          onClick={downloadPDF}
                          className="exclude-pdf"
                          style={{
                            marginLeft: "20px",
                            padding: "6px 12px",
                            background: "#111927",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          Download as PDF
                        </button>
                      }
                    </>
                  )}
                </div>
              </div>
              {!isMobile && <hr style={{ color: "#e5e7eb", border: "1px solid #e5e7eb" }} />}
              {isMobile ?
                <div className="mobile-report-details">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h4>{detailReport?.name}</h4>
                      <p>{detailReport?.emailId}</p>
                    </div>
                    <div>
                      <h4 style={{ color: '#0048B7', textAlign: 'center' }}>
                        {hideSensitive ? (
                          <span className="blur-text">***********</span>
                        ) : (
                          detailReport?.score
                        )}{detailReport?.score && '%'}
                      </h4>
                      <p>Overall Score</p>
                    </div>
                  </div>
                  <hr style={{ color: '#00DDFF' }} />
                  <div className="d-flex justify-content-between">
                    <div>
                      <p style={{ color: '#525B66', marginBottom: '6px', fontWeight: '500' }}>{detailReport?.testName}</p>
                      <p>{testDateTime.date} {testDateTime.time} | {detailReport?.candidateTestDuration} Minutes</p>
                    </div>
                    <div>
                      <p style={{ color: '#525B66', marginBottom: '6px', fontWeight: '500' }}>Test ID</p>
                      <p style={{}}>{detailReport?.testId}</p>
                    </div>
                  </div>
                </div>
                :
                <div className="row justify-content-between">
                  {!isInline && (
                    <div className="col-md-3 col-12">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4>{detailReport?.name}</h4>
                          <h6 className="mt-1">{detailReport?.emailId}</h6>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-md-9 col-12">
                    <div className={window.innerWidth > 767 ? "row" : "row mt-3"}>
                      <div className="col-md-3 col-3">
                        <h6>Test Name</h6>
                        <p>{detailReport?.testName}</p>
                      </div>
                      <div className="col-md-1 col-2">
                        <h6>Test Id</h6>
                        <p>{detailReport?.testId}</p>
                      </div>
                      <div className="col-md-2 col-2">
                        <h6>Test Date</h6>
                        <p>{testDateTime.date}</p>
                      </div>
                      <div className="col-md-1.5 col-2">
                        <h6>Test Time</h6>
                        <p>{testDateTime.time}</p>
                      </div>
                      <div className="col-md-2 col-2">
                        <h6>Test Duration</h6>
                        <p>{detailReport?.candidateTestDuration} Minutes</p>
                      </div>
                      {detailReport?.passFailStatus && (
                        <div className="col-md-1.5 col-2">
                          <h6>Pass Status</h6>
                          <p>{detailReport?.passFailStatus || "Null"}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              }
            </div>
            {!isMobile &&
              <div className="test-score">
                <h4 style={{ width: "50%", fontFamily: `"Manrope", sans-serif` }}>
                  Test Score Summary
                </h4>
                <div className="d-flex justify-content-between align-items-center">
                  {hasMixedTestNames || !hasOnlyExcludedTestNames ? (
                    <div>
                      <h2>
                        {hideSensitive ? (
                          <span className="blur-text">***</span>
                        ) : (
                          `${detailReport?.score}%`
                        )}
                      </h2>
                      <p>Overall Score</p>
                    </div>
                  ) : null}
                </div>
              </div>
            }
            <div className="individual-report">
              <h4>{isMobile ? "Test score summary" : "Individual Test Scores"}</h4>
              {detailReport?.dynamicEvaluationResult && (
                <div className="dynamic-evaluation mt-4 mb-4">
                  {/* Normalized Test Scores */}
                  <div className="dynamic-evaluation-section">
                    {detailReport.dynamicEvaluationResult.normalizedTestScores?.map(
                      (scoreItem, idx) => {
                        const relatedTest = detailReport.tests?.find(
                          (t) => t.testId === scoreItem.testId
                        );
                        return (
                          <div key={idx} className="dynamic-evaluation-item">
                            <span className="score">
                              {scoreItem.score?.toFixed(2)}
                            </span>
                            <span className="test-name">
                              {relatedTest?.testName ||
                                `Test ID: ${scoreItem.testId}`}
                            </span>
                          </div>
                        );
                      }
                    )}
                  </div>

                  {/* Alignment Results */}
                  <div className="dynamic-evaluation-section">
                    {detailReport.dynamicEvaluationResult.alignmentResults?.map(
                      (align, idx) => (
                        <div
                          key={idx}
                          className="dynamic-evaluation-item"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={`${align.band}`}
                        >
                          <span className="score">
                            {align.score?.toFixed(2)}
                          </span>
                          <span className="test-name">{align.displayName}</span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
              {detailReport?.tests?.length > 1 && (
                <p className="mt-2">Select test to view topic level scores</p>
              )}
              {!document.body.classList.contains("pdf-export") ? (
                <>
                  <div className="test-tabs">
                    {detailReport?.tests &&
                      detailReport?.tests?.map((el, i) => {
                        return (
                          <Fragment>
                            <div
                              className={
                                i === active ? "test-tab active" : "test-tab"
                              }
                              onClick={() => setActive(i)}
                            >
                              <div className="progress-circular">
                                <CircularProgressbarWithChildren
                                  value={
                                    el.referenceTypeId === 4 ||
                                      el.referenceTypeId === 2 ||
                                      el.referenceTypeId === 5
                                      ? 100
                                      : el.score
                                  }
                                  maxValue={100}
                                  minValue="0"
                                  styles={{
                                    root: {
                                      width: 80,
                                      height: 80,
                                      fontSize: 10,
                                      borderRadius: 150,
                                      marginTop: 0,
                                      // background: "#fff",
                                      verticalAlign: "middle",
                                      position: "relative",
                                    },
                                    path: {
                                      strokeLinecap: "square",
                                      stroke: "#0048b7",
                                      strokeWidth: 8,
                                    },
                                    trail: {
                                      // Trail color
                                      stroke: "#e5e7eb",
                                      strokeWidth: 8,
                                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                      strokeLinecap: "round",
                                    },
                                  }}
                                >
                                  <div
                                    className="text-center"
                                    style={{
                                      fontSize: 14,
                                      color: "#3d4143",
                                      fontFamily: "Poppins",
                                    }}
                                  >
                                    {el.referenceTypeId === 2 ||
                                      el.referenceTypeId === 4 ||
                                      el.referenceTypeId === 5 ? (
                                      <strong
                                        style={{ fontSize: 10 }}
                                        className="text-center"
                                      >
                                        {"Completed"}
                                      </strong>
                                    ) : (
                                      <strong className="text-center">
                                        {hideSensitive ? (
                                          <span className="blur-text">***</span>
                                        ) : (
                                          `${el.score}%`
                                        )}
                                      </strong>
                                    )}
                                  </div>
                                </CircularProgressbarWithChildren>
                              </div>
                              <h5>{el.testName}</h5>
                            </div>
                          </Fragment>
                        );
                      })}
                  </div>
                  <div
                    className="tab-content d-flex flex-wrap mt-2"
                    style={{ minHeight: 280 }}
                  >
                    <div
                      className="test-topic mt-3 ms-2"
                      style={{
                        width:
                          window.innerWidth > 767
                            ? detailReport?.tests[active]?.referenceTypeId === 4 ||
                              detailReport?.tests[active]?.referenceTypeId === 3 ||
                              detailReport?.tests[active]?.referenceTypeId === 6 ||
                              (detailReport?.tests[active]?.referenceTypeId === 1 &&
                                (detailReport?.tests[active]?.testType === 7 || detailReport?.tests[active]?.testType === 8 || detailReport?.tests[active]?.testType === 4)) ||
                              !detailReport?.tests[active]?.topics?.length
                              ? "100%"
                              : "65%"
                            : "100%",
                      }}
                    >
                      {detailReport?.tests &&
                        detailReport?.tests[active]?.referenceTypeId === 1 &&
                        ![7, 8].includes(
                          detailReport?.tests[active]?.testType
                        ) ? (
                        <Table responsiopenOneReportve bordered={false}>
                          {!detailReport?.tests[active]?.topics
                            ?.length || detailReport?.tests[active]?.questions?.[0]
                              ?.questionTypeId === 14 ? null : detailReport?.tests[active]
                                ?.testType === 5 ? (
                            <thead>
                              <th>Question</th>
                              <th>Correct</th>
                            </thead>
                          ) : (
                            <thead>
                              <th>Topic level scores</th>
                              <th>
                                Topic Average -
                                {detailReport?.tests[active]?.score}%
                              </th>
                            </thead>
                          )}
                          <tbody style={{ verticalAlign: "baseline" }}>
                            {!detailReport?.tests[active]?.topics?.length || detailReport?.tests[active]?.questions?.[0]?.questionTypeId === 14 ? (
                              <div>
                                <Accordion
                                  activeKey={
                                    activeKey === "all"
                                      ? detailReport.tests.map((_, i) =>
                                        i.toString()
                                      )
                                      : activeKey
                                  }
                                >
                                  {detailReport?.tests[active]?.questions
                                    ?.map(
                                      (el) =>
                                        [
                                          {
                                            ...el,
                                            correct:
                                              el.isAnswered === 0
                                                ? false
                                                : true,
                                            correct_id:
                                              el.questionOptions.filter(
                                                (id) => id.iscorrect
                                              )[0]?.questionOptionID,
                                          },
                                        ][0]
                                    )
                                    .map((el, i) => {
                                      return (
                                        <Card>
                                          <Card.Header>
                                            <div
                                              className="d-flex align-items-center justify-content-between"
                                              as={Button}
                                              variant="link"
                                              eventKey={i}
                                              onClick={() =>
                                                handleAccordionClick(i)
                                              }
                                            >
                                              <span
                                                style={{ width: "70%", display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis" }}
                                                dangerouslySetInnerHTML={{
                                                  __html: el.question,
                                                }}
                                              />{" "}
                                              <p
                                                style={{
                                                  width: "15%",
                                                  fontSize: 16,
                                                  color: "#000000",
                                                }}
                                              >
                                                Type:{" "}
                                                {el.questionTypeId === 1
                                                  ? "MCQ"
                                                  : el.questionTypeId === 11
                                                    ? "Rating"
                                                    : el.questionTypeId === 14
                                                      ? "File Based"
                                                      : "Essay"}
                                              </p>
                                              &nbsp;&nbsp;{" "}
                                              <p
                                                style={{
                                                  width: "15%",
                                                  fontSize: 16,
                                                  color: "#000000",
                                                  border: 'none'
                                                }}
                                              >
                                                {!isMobile && 'Score :'}
                                                {" "}
                                                {el.reviewStatus === 2 ? (
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    Pending
                                                  </span>
                                                ) : (
                                                  `${el.answerScore} / ${el.score}`
                                                )}
                                              </p>{" "}
                                              {accordionIcon(i)}
                                            </div>
                                          </Card.Header>
                                          <Accordion.Collapse eventKey={i}>
                                            <Card.Body>
                                              <div
                                                className=" mt-2 px-2"
                                                dangerouslySetInnerHTML={{
                                                  __html: el.description,
                                                }}
                                              />

                                              {el.questionTypeId === 1 ||
                                                el.questionTypeId === 11 ? (
                                                <>
                                                  <ul className="ques-options">
                                                    {el?.questionOptions?.map(
                                                      (option, i) => {
                                                        const isSelected =
                                                          el.selectedOptionId ===
                                                          option.questionOptionID;
                                                        return (
                                                          <li
                                                            className={
                                                              el.questionTypeId ===
                                                                11
                                                                ? isSelected
                                                                  ? "correct"
                                                                  : ""
                                                                : el.correct_id ===
                                                                  option.questionOptionID &&
                                                                  el.correct
                                                                  ? "correct"
                                                                  : el.correct ===
                                                                    false &&
                                                                    el.selectedOptionId ===
                                                                    option.questionOptionID
                                                                    ? "incorrect"
                                                                    : el.correct_id ===
                                                                      option.questionOptionID
                                                                      ? "correct"
                                                                      : null
                                                            }
                                                          >
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  option.questionOption,
                                                              }}
                                                            />
                                                            {el.correct_id ===
                                                              el.selectedOptionId &&
                                                              el.correct ? (
                                                              <img
                                                                src="/images/correct.svg"
                                                                alt=""
                                                              />
                                                            ) : !el.correct &&
                                                              option.questionOptionID ===
                                                              el.selectedOptionId ? (
                                                              <img
                                                                src="/images/incorrect.svg"
                                                                alt=""
                                                              />
                                                            ) : el.correct_id ===
                                                              option.questionOptionID ? (
                                                              <img
                                                                src="/images/correct.svg"
                                                                alt=""
                                                              />
                                                            ) : null}
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                  {el.shouldProvideReason ===
                                                    1 &&
                                                    el.reason && <hr />}
                                                  {el.shouldProvideReason ===
                                                    1 &&
                                                    el.reason && (
                                                      <div className="mt-3 px-2">
                                                        <strong>
                                                          Justification
                                                        </strong>
                                                        <p
                                                          style={{
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            border:
                                                              "1px solid #e0e0e0",
                                                            borderRadius: "4px",
                                                            padding: "8px",
                                                            fontSize: "14px",
                                                            color: "#333",
                                                          }}
                                                        >
                                                          {el.reason}
                                                        </p>
                                                      </div>
                                                    )}
                                                </>
                                              ) : el.questionTypeId === 14 ? (
                                                (() => {
                                                  const file =
                                                    getFileFromAnswerData(
                                                      el.answerData
                                                    );

                                                  return file ? (
                                                    <div
                                                      className="file-chip d-flex align-items-center justify-content-between"
                                                      style={{
                                                        marginTop: "10px",
                                                      }}
                                                    >
                                                      <div className="d-flex gap-2">
                                                        <p>
                                                          This File is uploaded by
                                                          candidate in test as
                                                          answer for the question.
                                                        </p>
                                                        {!isSharedReport && !hideSensitive && (
                                                          <>
                                                            <img
                                                              src="/images/edit-icon.svg"
                                                              alt="Edit"
                                                              style={{
                                                                width: 18,
                                                                height: 18,
                                                                marginLeft: 8,
                                                                cursor: "pointer",
                                                              }}
                                                              onClick={() => {
                                                                setSelectedQuestion({
                                                                  ...el,
                                                                  candidateQuestionId:
                                                                    el.candidateTestQuestionId,
                                                                });
                                                                setEditScore(
                                                                  el.answerScore || 0
                                                                );
                                                                setEditComment("");
                                                                setShowEditPopup(true);
                                                              }}
                                                            />

                                                            <img
                                                              src="/images/comment-icon.svg"
                                                              alt="Comments"
                                                              style={{
                                                                width: 18,
                                                                height: 18,
                                                                marginLeft: 8,
                                                                cursor: "pointer",
                                                              }}
                                                              onClick={() =>
                                                                handleViewComments(el)
                                                              }
                                                            />
                                                          </>
                                                        )}
                                                      </div>
                                                      <div>
                                                        <span>{file.name}</span>
                                                        &nbsp;&nbsp;
                                                        <img
                                                          src="/images/download-pink.svg"
                                                          alt="download"
                                                          className="cursor-pointer"
                                                          width={22}
                                                          height={22}
                                                          onClick={() =>
                                                            downloadFile(
                                                              file.url,
                                                              file.name
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <p
                                                      style={{
                                                        color: "#6B7280",
                                                      }}
                                                    >
                                                      No file uploaded
                                                    </p>
                                                  );
                                                })()
                                              ) : (
                                                <div>
                                                  <textarea
                                                    className="form-control"
                                                    value={el.answerText}
                                                    disabled
                                                  />
                                                </div>
                                              )}
                                            </Card.Body>
                                          </Accordion.Collapse>
                                        </Card>
                                      );
                                    })}
                                </Accordion>
                              </div>
                            ) : detailReport?.tests[active]?.testType === 5 ? (
                              detailReport?.tests[active].questions?.map(
                                (el1, i) => {
                                  return (
                                    <tr>
                                      <td
                                        style={{ fontSize: 16 }}
                                        dangerouslySetInnerHTML={{
                                          __html: el1?.question,
                                        }}
                                      ></td>
                                      <td>
                                        {el1.isAnswered === 0 ? (
                                          <img
                                            src="/images/close-check-red.svg"
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            src="/images/green-check.svg"
                                            alt=""
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              detailReport?.tests[active]?.topics?.map(
                                (el1) => {
                                  return (
                                    <tr>
                                      <td>{el1.skillTopicName}</td>
                                      <td>
                                        <div className="d-flex">
                                          {!isMobile &&
                                            <ProgressBar
                                              style={{ width: "50%" }}
                                              variant="succ"
                                              now={el1.score}
                                            />
                                          }{" "}
                                          &nbsp;
                                          <p>{el1.score}%</p>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            )}
                          </tbody>
                        </Table>
                      ) : (detailReport?.tests[active]?.referenceTypeId === 3 &&
                        detailReport?.tests[active]?.codingQuestions?.length >
                        0) ||
                        (detailReport?.tests[active]?.referenceTypeId === 1 &&
                          (detailReport?.tests[active]?.testType === 7 ||
                            detailReport?.tests[active]?.testType === 8)) ||
                        (detailReport?.tests[active]?.referenceTypeId === 6 &&
                          detailReport?.tests[active]?.databaseQuestions
                            ?.length > 0) ? (
                        <div>
                          <Accordion activeKey={activeKey}>
                            {(detailReport?.tests[active]?.referenceTypeId ===
                              3 ||
                              (detailReport?.tests[active]?.referenceTypeId ===
                                1 &&
                                (detailReport?.tests[active]?.testType === 7 ||
                                  detailReport?.tests[active]?.testType === 8))
                              ? detailReport?.tests[active]?.codingQuestions
                              : detailReport?.tests[active]?.databaseQuestions
                            ).map((el, i) => {
                              return (
                                <Card key={i}>
                                  <Card.Header>
                                    <div
                                      className="d-flex align-items-center justify-content-between"
                                      as={Button}
                                      variant="link"
                                      eventKey={i}
                                      onClick={() => handleAccordionClick(i)}
                                    >
                                      <span style={{ width: isMobile ? '' : "80%" }}>
                                        {el.question}
                                      </span>{" "}
                                      <p
                                        style={{
                                          fontSize: 16,
                                          color: "#000000",
                                          border: 'none',
                                          padding: '0'
                                        }}
                                      >
                                        {!isMobile && 'Score :'} {el.candidateScore} / {el.score}
                                      </p>
                                      {accordionIcon(i)}
                                    </div>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={i}>
                                    <Card.Body>
                                      <p className="ques-describe">
                                        Problem Statement
                                      </p>
                                      <div
                                        className=" mt-2 px-2"
                                        dangerouslySetInnerHTML={{
                                          __html: el.description,
                                        }}
                                      />
                                      <div className="mt-3">
                                        <p className="ques-describe d-flex align-items-center" style={{ justifyContent: isMobile ? 'space-between' : '' }}>
                                          Score&nbsp;&nbsp;
                                          <div>
                                            {detailReport?.tests[active]
                                              ?.referenceTypeId === 1 &&
                                              (detailReport?.tests[active]
                                                ?.testType === 7 ||
                                                detailReport?.tests[active]
                                                  ?.testType === 8) && !hideSensitive && (
                                                <img
                                                  src="/images/edit-icon.svg"
                                                  alt="Edit"
                                                  style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    marginLeft: "6px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedQuestion(el);
                                                    setEditScore(
                                                      el.candidateScore || 0
                                                    );
                                                    setEditComment("");
                                                    setShowEditPopup(true);
                                                  }}
                                                />
                                              )}
                                            {detailReport?.tests[active]
                                              ?.referenceTypeId === 1 &&
                                              (detailReport?.tests[active]
                                                ?.testType === 7 ||
                                                detailReport?.tests[active]
                                                  ?.testType === 8) &&
                                              !isSharedReport && !hideSensitive && (
                                                <img
                                                  src="/images/comment-icon.svg"
                                                  alt="Summary"
                                                  style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    marginLeft: "10px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    handleViewComments(el)
                                                  }
                                                />
                                              )}
                                          </div>
                                        </p>
                                        <h4 className="mt-2 px-2">
                                          {el.candidateScore} / {el.score}
                                        </h4>
                                      </div>
                                      {el.finalCodeSubmitted && (
                                        <div className="mt-3 ">
                                          <p className="ques-describe">
                                            Final Code Submitted
                                          </p>
                                          <div
                                            className=" mt-2 px-2"
                                            dangerouslySetInnerHTML={{
                                              __html: el.finalCodeSubmitted,
                                            }}
                                          />
                                        </div>
                                      )}
                                      {el.answerMetaData ? (
                                        (() => {
                                          let meta = {};
                                          try {
                                            meta = JSON.parse(
                                              el.answerMetaData
                                            );
                                          } catch { }
                                          return (
                                            <div className="mt-3">
                                              <p className="ques-describe">
                                                Answer Data
                                              </p>

                                              {/* Notebook Download */}
                                              {meta.NotebookUrl && (
                                                <div
                                                  className="d-flex align-items-center mb-2"
                                                  style={{
                                                    cursor: "pointer",
                                                    marginBottom: "5px",
                                                  }}
                                                  onClick={() =>
                                                    downloadFile(
                                                      meta.NotebookUrl,
                                                      "notebook.ipynb"
                                                    )
                                                  }
                                                >
                                                  <span>notebook.ipynb</span>
                                                  <img
                                                    src="/images/download-pink.svg"
                                                    alt="download"
                                                    style={{
                                                      width: "18px",
                                                      marginLeft: "8px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              {/* Output CSV Download */}
                                              {meta.outputBlobUrl && (
                                                <div
                                                  className="d-flex align-items-center mb-2"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    downloadFile(
                                                      meta.outputBlobUrl,
                                                      "output.csv"
                                                    )
                                                  }
                                                >
                                                  <span>output.csv</span>
                                                  <img
                                                    src="/images/download-pink.svg"
                                                    alt="download"
                                                    style={{
                                                      width: "18px",
                                                      marginLeft: "8px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              {/* Metric Score */}
                                              <div className="mt-2">
                                                <h6
                                                  style={{ fontWeight: "600" }}
                                                >
                                                  Metric Score ={" "}
                                                  {meta?.score ?? 0}
                                                </h6>
                                              </div>
                                            </div>
                                          );
                                        })()
                                      ) : (
                                        <div className="mt-3">
                                          <p className="ques-describe">
                                            Compilation Statistics
                                          </p>
                                          <div className="div-row1 px-2">
                                            <div className="col-md-4 d-flex flex-column align-items-center">
                                              <div
                                                className="circle"
                                                style={{
                                                  borderColor: "#0048b7",
                                                  color: "#0048b7",
                                                }}
                                              >
                                                {el.totalAttempts}
                                              </div>
                                              <h6>Total Attempts</h6>
                                            </div>

                                            <div className="col-md-4 d-flex flex-column align-items-center">
                                              <div
                                                className="circle"
                                                style={{
                                                  borderColor: "green",
                                                  color: "green",
                                                }}
                                              >
                                                {el.succesfulAttempts}
                                              </div>
                                              <h6>Successful</h6>
                                            </div>

                                            <div className="col-md-4 d-flex flex-column align-items-center">
                                              <div
                                                className="circle"
                                                style={{
                                                  borderColor: "red",
                                                  color: "red",
                                                }}
                                              >
                                                {el.errors}
                                              </div>
                                              <h6>Errors</h6>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {el.executions?.length ? (
                                        <div className="mt-3">
                                          <p className="ques-describe">
                                            Test Cases
                                          </p>
                                          <div className="px-2 mt-2">
                                            {el.executions?.map((el1, ind) => {
                                              return (
                                                <div className="col-md-12 d-flex align-items-center mb-3">
                                                  <h6>Test Case {ind + 1}</h6>
                                                  <h6 className="ms-5">
                                                    {el1.statusId === 1 ? (
                                                      <img
                                                        src="/images/green-check.svg"
                                                        alt=""
                                                      />
                                                    ) : (
                                                      <img
                                                        src="/images/close-check-red.svg"
                                                        alt=""
                                                      />
                                                    )}
                                                  </h6>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              );
                            })}
                          </Accordion>
                        </div>
                      ) : detailReport?.tests[active]?.referenceTypeId === 4 ? (
                        <div>
                          <div className="mt-3">
                            {
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "column",
                                    height: 270,
                                  },
                                  legend: {
                                    enabled: false,
                                  },

                                  title: {
                                    text: "",
                                  },

                                  colors: ["#51488c"],
                                  xAxis: {
                                    categories: detailReport?.tests[
                                      active
                                    ]?.personalityTopics?.map((el) => el.topic),
                                    type: "Months",
                                    title: {
                                      text: "Competencies",
                                    },
                                  },
                                  yAxis: {
                                    type: "Scores",
                                    title: {
                                      text: "",
                                    },
                                  },
                                  plotOptions: {
                                    series: {
                                      animation: false,
                                      pointWidth: 30,
                                      dataLabels: {
                                        enabled: true,
                                        crop: false,
                                        overflow: false,
                                        format: "{y} %",
                                      },
                                    },
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  series: [
                                    {
                                      enableMouseTracking: false,
                                      showInLegend: false,
                                      grouping: false,
                                      data: detailReport?.tests[
                                        active
                                      ]?.personalityTopics?.map(
                                        (el) => el.percentage
                                      ),
                                    },
                                  ],
                                }}
                              />
                            }
                          </div>
                          {detailReport?.tests[active]?.personalityTopics.map(
                            (personality) => (
                              <div
                                className="personality "
                                style={{ marginTop: "3%" }}
                              >
                                <div style={{ display: "flex" }}>
                                  <h1 style={{ flex: "1" }}>
                                    {personality.topic}
                                  </h1>
                                  <div style={{ flex: "1" }}>
                                    <div style={{ width: "100%" }}>
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ position: "relative" }}
                                      >
                                        <svg
                                          version="1.1"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="currentColor"
                                          width="35"
                                          height="35"
                                          viewBox="0 0 64 64"
                                          style={{
                                            position: "absolute",
                                            left: `${personality.percentage}%`,
                                            transform: "translate(-50%, -15%)",
                                          }}
                                        >
                                          <path
                                            d="M0 0 C4.94895464 3.00548104 8.39324937 7.12338505 10.875 12.3125 C13.7325779 26.60038948 6.58084435 38.14676314 -0.984375 49.734375 C-3.93702588 54.14312769 -7.08922388 58.37167416 -10.5 62.4375 C-13.73914606 61.06790784 -15.32321442 59.71043276 -17.26953125 56.796875 C-18.00949341 55.69496826 -18.00949341 55.69496826 -18.7644043 54.57080078 C-19.27527588 53.78431152 -19.78614746 52.99782227 -20.3125 52.1875 C-20.84077393 51.38425293 -21.36904785 50.58100586 -21.91333008 49.75341797 C-36.63372398 27.00228398 -36.63372398 27.00228398 -34.109375 13.3203125 C-32.32888342 7.45382101 -28.50330456 3.82801774 -23.5 0.4375 C-16.67636021 -2.99146472 -6.9834852 -3.14729604 0 0 Z "
                                            fill="#1581B4"
                                            transform="translate(43.5,1.5625)"
                                          />
                                        </svg>
                                        &nbsp;
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#fff",
                                            position: "absolute",
                                            left: `${personality.percentage}%`,
                                            transform: "translate(-45%, -40%)",
                                            zIndex: 1,
                                          }}
                                        >
                                          {`${Math.floor(
                                            personality.percentage
                                          )}`}
                                        </div>
                                      </div>
                                      <div style={progressStyle}></div>
                                      <div className="d-flex align-items-center">
                                        <div style={{ marginRight: "auto" }}>
                                          {personality.Minbar}
                                        </div>
                                        <div style={{ marginLeft: "auto" }}>
                                          {personality.Maxbar}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <br />
                                <p style={{ lineHeight: "2" }}>
                                  {personality?.topicDescription}
                                </p>
                                <hr></hr>
                              </div>
                            )
                          )}
                        </div>
                      ) : detailReport?.tests[active]?.referenceTypeId === 5 ? (
                        <div>
                          {detailReport?.tests[active]?.mbtiTestResult !== null
                            ? getMbtiResult(
                              detailReport?.tests[active]?.mbtiTestResult
                            ).map((personality) => (
                              <div
                                className="personality "
                                style={{ marginTop: "3%" }}
                              >
                                <div style={{ display: "flex" }}>
                                  <h1 style={{ flex: "1" }}>
                                    <p style={{ color: "#000" }}>Type</p>{" "}
                                    {personality?.type}
                                  </h1>
                                </div>
                                <br />
                                <div style={{ display: "flex" }}>
                                  <h1 style={{ flex: "1" }}>
                                    <p style={{ color: "#000" }}>Nick Name</p>{" "}
                                    {personality?.nickname}
                                  </h1>
                                </div>
                                <br />
                                <p style={{ color: "#000" }}>Description</p>
                                <p className="mt-1">
                                  {personality?.description}
                                </p>
                                <hr></hr>
                              </div>
                            ))
                            : null}
                        </div>
                      ) : (detailReport?.tests[active]?.questions?.length ||
                        detailReport?.tests[active]?.topics?.length) > 0 ? (
                        <Table responsiopenOneReportve bordered={false}>
                          {detailReport?.tests[active]?.referenceTypeId ===
                            2 ? null : (
                            <thead>
                              <th>Topic level scores</th>
                              <th>
                                Topic Average -
                                {detailReport?.tests[active]?.score}%
                              </th>
                            </thead>
                          )}
                          <tbody style={{ verticalAlign: "baseline" }}>
                            {detailReport?.tests[active]?.referenceTypeId ===
                              2 ? (
                              <div>
                                <Accordion activeKey={activeKey}>
                                  {detailReport?.tests[active]?.questions
                                    ?.map(
                                      (el) =>
                                        [
                                          {
                                            ...el,
                                            correct:
                                              el.isAnswered === 0
                                                ? false
                                                : true,
                                            correct_id:
                                              el.questionOptions.filter(
                                                (id) => id.iscorrect
                                              )[0]?.questionOptionID,
                                          },
                                        ][0]
                                    )
                                    .map((el, i) => {
                                      return (
                                        <Card>
                                          <Card.Header>
                                            <div
                                              className="d-flex align-items-center justify-content-between"
                                              as={Button}
                                              variant="link"
                                              eventKey={i}
                                              onClick={() =>
                                                handleAccordionClick(i)
                                              }
                                            >
                                              <span
                                                style={{ width: "70%" }}
                                                dangerouslySetInnerHTML={{
                                                  __html: el.question,
                                                }}
                                              />{" "}
                                              <p
                                                style={{
                                                  width: "15%",
                                                  fontSize: 16,
                                                  color: "#000000",
                                                }}
                                              >
                                                Type:{" "}
                                                {el.questionTypeId === 1
                                                  ? "MCQ"
                                                  : el.questionTypeId === 11
                                                    ? "Rating"
                                                    : el.questionTypeId === 14
                                                      ? "File Based"
                                                      : "Essay"}
                                              </p>
                                              &nbsp;&nbsp;{" "}
                                              <p
                                                style={{
                                                  width: "15%",
                                                  fontSize: 16,
                                                  color: "#000000",
                                                  border: 'none'
                                                }}
                                              >
                                                {!isMobile && 'Score :'}{" "}
                                                {el.reviewStatus === 2 ? (
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    Pending
                                                  </span>
                                                ) : (
                                                  `${el.answerScore} / ${el.score}`
                                                )}
                                              </p>{" "}
                                              {accordionIcon(i)}
                                            </div>
                                          </Card.Header>
                                          <Accordion.Collapse eventKey={i}>
                                            <Card.Body>
                                              <div
                                                className=" mt-2 px-2"
                                                dangerouslySetInnerHTML={{
                                                  __html: el.description,
                                                }}
                                              />

                                              {el.questionTypeId === 1 ||
                                                el.questionTypeId === 11 ? (
                                                <>
                                                  <ul className="ques-options">
                                                    {el?.questionOptions?.map(
                                                      (option, i) => {
                                                        return (
                                                          <li
                                                            className={
                                                              el.correct_id ===
                                                                option.questionOptionID &&
                                                                el.correct
                                                                ? "correct"
                                                                : el.correct ===
                                                                  false &&
                                                                  el.selectedOptionId ===
                                                                  option.questionOptionID
                                                                  ? "incorrect"
                                                                  : el.correct_id ===
                                                                    option.questionOptionID
                                                                    ? "correct"
                                                                    : null
                                                            }
                                                          >
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  option.questionOption,
                                                              }}
                                                            />
                                                            {el.correct_id ===
                                                              el.selectedOptionId &&
                                                              el.correct ? (
                                                              <img
                                                                src="/images/correct.svg"
                                                                alt=""
                                                              />
                                                            ) : !el.correct &&
                                                              option.questionOptionID ===
                                                              el.selectedOptionId ? (
                                                              <img
                                                                src="/images/incorrect.svg"
                                                                alt=""
                                                              />
                                                            ) : el.correct_id ===
                                                              option.questionOptionID ? (
                                                              <img
                                                                src="/images/correct.svg"
                                                                alt=""
                                                              />
                                                            ) : null}
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                  {el.shouldProvideReason ===
                                                    1 &&
                                                    el.reason && <hr />}
                                                  {el.shouldProvideReason ===
                                                    1 &&
                                                    el.reason && (
                                                      <div className="mt-3 px-2">
                                                        <strong>
                                                          Justification
                                                        </strong>
                                                        <p
                                                          style={{
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            border:
                                                              "1px solid #e0e0e0",
                                                            borderRadius: "4px",
                                                            padding: "8px",
                                                            fontSize: "14px",
                                                            color: "#333",
                                                          }}
                                                        >
                                                          {el.reason}
                                                        </p>
                                                      </div>
                                                    )}
                                                </>
                                              ) : (
                                                <div>
                                                  <textarea
                                                    className="form-control"
                                                    value={el.answerText}
                                                    disabled
                                                  />
                                                </div>
                                              )}
                                              {el.reviewStatus === 2 &&
                                                !isSharedReport && !hideSensitive && (
                                                  <>
                                                    <img
                                                      src="/images/edit-icon.svg"
                                                      alt="Edit"
                                                      style={{
                                                        width: 18,
                                                        height: 18,
                                                        marginLeft: 8,
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        setSelectedQuestion({
                                                          ...el,
                                                          candidateQuestionId:
                                                            el.candidateTestQuestionId,
                                                        });
                                                        setEditScore(
                                                          el.answerScore || 0
                                                        );
                                                        setEditComment("");
                                                        setShowEditPopup(true);
                                                      }}
                                                    />

                                                    <img
                                                      src="/images/comment-icon.svg"
                                                      alt="Comments"
                                                      style={{
                                                        width: 18,
                                                        height: 18,
                                                        marginLeft: 8,
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleViewComments(el)
                                                      }
                                                    />
                                                  </>
                                                )}
                                            </Card.Body>
                                          </Accordion.Collapse>
                                        </Card>
                                      );
                                    })}
                                </Accordion>
                              </div>
                            ) : (
                              detailReport?.tests[active]?.topics?.map(
                                (el1) => {
                                  return (
                                    <tr>
                                      <td>{el1.skillTopicName}</td>
                                      <td>
                                        <div className="d-flex">
                                          {!isMobile &&
                                            <ProgressBar
                                              style={{ width: "50%" }}
                                              variant="succ"
                                              now={el1.score}
                                            />}{" "}
                                          &nbsp;
                                          <p>{el1.score}%</p>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            )}
                          </tbody>
                        </Table>
                      ) : detailReport?.tests[active]?.referenceTypeId === 7 ? (
                        renderFullTestBlock(detailReport.tests[active], active)
                      ) : (
                        "No data available"
                      )}
                    </div>
                    {detailReport?.tests[active]?.testType === 5 ||
                      detailReport?.tests[active]?.testName ===
                      "Additional Questions" ||
                      detailReport?.tests[active]?.referenceTypeId === 4 ||
                      detailReport?.tests[active]?.referenceTypeId === 5 ||
                      detailReport?.tests[active]?.referenceTypeId === 7 ||
                      detailReport?.tests[active]?.questions?.[0]?.questionTypeId === 14 || hideSensitive
                      ? null : (
                        <div
                          className="test-topic mt-3 ms-2"
                          style={{
                            width: window.innerWidth > 767 ? "20%" : "100%",
                          }}
                        >
                          <Table responsive bordered={false}>
                            <thead>
                              <th>Difficulty level scores</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center" style={{ justifyContent: isMobile ? 'space-between' : '' }}>
                                    <h6>Easy</h6>&nbsp;
                                    <div className="d-flex" style={{ width: isMobile ? '50%' : '' }}>
                                      <ProgressBar
                                        style={{ width: "50%" }}
                                        variant="succ"
                                        now={
                                          detailReport?.tests[active]
                                            ?.easyLevelScore
                                        }
                                      />{" "}
                                      &nbsp;
                                      <p className="d-flex align-items-center">
                                        {detailReport?.tests[active]
                                          ?.easyLevelScore || 0}
                                        %
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center" style={{ justifyContent: isMobile ? 'space-between' : '' }}>
                                    <h6>Medium</h6>&nbsp;
                                    <div className="d-flex" style={{ width: isMobile ? '50%' : '' }}>
                                      <ProgressBar
                                        style={{ width: "50%" }}
                                        variant="succ"
                                        now={
                                          detailReport?.tests[active]
                                            ?.mediumLevelScore
                                        }
                                      />{" "}
                                      &nbsp;
                                      <p className="d-flex align-items-center">
                                        {detailReport?.tests[active]
                                          ?.mediumLevelScore || 0}
                                        %
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex  align-items-center" style={{ justifyContent: isMobile ? 'space-between' : '' }}>
                                    <h6>Hard</h6>&nbsp;
                                    <div className="d-flex" style={{ width: isMobile ? '50%' : '' }}>
                                      <ProgressBar
                                        style={{ width: "50%" }}
                                        variant="succ"
                                        now={
                                          detailReport?.tests[active]
                                            ?.hardLevelScore
                                        }
                                      />{" "}
                                      &nbsp;
                                      <p className="d-flex align-items-center">
                                        {detailReport?.tests[active]
                                          ?.hardLevelScore || 0}
                                        %
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      )}
                  </div>
                </>
              ) : (
                renderAllTestsForPDF()
              )}
            </div>
            {!document.body.classList.contains("pdf-export") &&
              detailReport?.capturedImages?.length > 0 && (
                <div className="image-lists">
                  <h4>Proctoring analysis</h4>
                  {proctoringReport && proctoringReport.candidateTestId && (
                    <div className="proctoring-report">
                      <div className="proctoring-report-item">
                        <div className="proctoring-report-count">
                          <img src="/images/browser-black-icon.svg" alt="" />
                          <h6>{proctoringReport?.browsersUsed}</h6>
                        </div>
                        <p>Browsers used</p>
                      </div>
                      <div className="proctoring-report-item">
                        <div className="proctoring-report-count">
                          <img src="/images/diamond-turn-right.svg" alt="" />
                          <h6>{proctoringReport?.navigationViolations}</h6>
                        </div>
                        <p>Navigation violations</p>
                      </div>
                      <div className="proctoring-report-item">
                        <div>
                          <div className="proctoring-report-count">
                            <img src="/images/time-fast.svg" alt="" />
                            <h6>
                              {proctoringReport?.testWindowViolationTime} sec
                            </h6>
                          </div>
                        </div>
                        <p>Test window violations</p>
                      </div>
                      <div className="proctoring-report-item">
                        <div>
                          <div className="proctoring-report-count">
                            <img src="/images/webcam-icon.svg" alt="" />
                            <h6>{proctoringReport?.webcamViolations}</h6>
                          </div>
                        </div>
                        <p>Webcam violations</p>
                      </div>
                    </div>
                  )}
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    {processedImages.map((el, i) => {
                      let analysis = {};
                      try {
                        analysis = el.analysis ? JSON.parse(el.analysis) : {};
                      } catch { }

                      const cheating = analysis?.CheatingDetected === true;
                      const summary = analysis?.Summary || "";

                      return (
                        <div
                          key={i}
                          className="image-list"
                          style={{
                            position: "relative",
                            border: cheating ? "3px solid red" : "",
                            textAlign: "center",
                            backgroundColor: "#fff",
                            cursor: "pointer",
                          }}
                          data-bs-toggle={summary ? "tooltip" : ""}
                          title={summary}
                          onClick={() => {
                            setSelectedImageIndex(i);
                            setImage(el.imageURL);
                            setOpenBox(true);
                          }}
                        >
                          <img src={el.imageURL} alt="" />
                          <span className="time">
                            {formatAMPM(el.addedDate)}
                          </span>
                        </div>
                      );
                    })}
                    {detailReport?.capturedImages?.length > 7 && (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "15px",
                          cursor: "pointer",
                          fontWeight: 600,
                          color: "#0048b7",
                        }}
                        onClick={() => setShowAllImages(!showAllImages)}
                      >
                        {showAllImages ? "View Less" : "View All"}
                      </div>
                    )}
                  </div>
                </div>
              )}
            {!document.body.classList.contains("pdf-export") &&
              detailReport?.tests[active]?.referenceTypeId === 1 &&
              (detailReport?.tests[active]?.testType === 0 || (detailReport?.tests[active]?.testType === 4 && detailReport?.tests[active]?.questions?.[0]?.questionTypeId !== 14)) ? (
              <div className="according-items">
                <Accordion
                  activeKey={
                    activeKey === "all"
                      ? detailReport?.tests[active]?.questions?.map((_, i) =>
                        i.toString()
                      )
                      : activeKey
                  }
                >
                  {detailReport?.tests[active]?.questions
                    ?.map(
                      (el) =>
                        [
                          {
                            ...el,
                            correct: el.isAnswered === 0 ? false : true,
                            correct_id: el.questionOptions.filter(
                              (id) => id.iscorrect
                            )[0]?.questionOptionID,
                          },
                        ][0]
                    )
                    .map((el, i) => {
                      return (
                        <Card>
                          <Card.Header>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              as={Button}
                              variant="link"
                              eventKey={i}
                              onClick={() => handleAccordionClick(i)}
                            >
                              <span
                                style={{ width: isMobile ? '100%' : "70%", overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical' }}
                                dangerouslySetInnerHTML={{
                                  __html: el.question,
                                }}
                              />{" "}
                              {!isMobile &&
                                <p
                                  style={{
                                    width: "15%",
                                    fontSize: 16,
                                    color: "#000000",
                                  }}
                                >
                                  Type:{" "}
                                  {el.questionTypeId === 1
                                    ? "MCQ"
                                    : el.questionTypeId === 11
                                      ? "Rating"
                                      : el.questionTypeId === 14
                                        ? "File Based"
                                        : "Essay"}
                                </p>
                              }
                              &nbsp;&nbsp;{" "}
                              {!isMobile &&
                                <p
                                  style={{
                                    width: "15%",
                                    fontSize: 16,
                                    color: "#000000",
                                    border: 'none'
                                  }}
                                >
                                  {!isMobile && 'Score :'}{" "}
                                  {el.reviewStatus === 2 ? (
                                    <span style={{ color: "red" }}>Pending</span>
                                  ) : (
                                    `${el.answerScore} / ${el.score}`
                                  )}
                                </p>}{" "}
                              {accordionIcon(i)}
                            </div>
                          </Card.Header>
                          <Accordion.Collapse eventKey={i}>
                            <Card.Body>
                              <div
                                className=" mt-2 px-2"
                                dangerouslySetInnerHTML={{
                                  __html: el.description,
                                }}
                              />

                              {el.questionTypeId === 1 ||
                                el.questionTypeId === 11 ? (
                                <>
                                  <ul
                                    className="ques-options"
                                    style={{
                                      listStyle: "none",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {el.questionOptions.map((option, j) => {
                                      const isSelected =
                                        el.selectedOptionId ===
                                        option.questionOptionID;
                                      const isCorrect = option.iscorrect;

                                      return (
                                        <li
                                          key={j}
                                          className={`option-item ${el.questionTypeId === 11
                                            ? isSelected
                                              ? "correct"
                                              : ""
                                            : isCorrect
                                              ? "correct"
                                              : isSelected && !isCorrect
                                                ? "incorrect"
                                                : ""
                                            }`}
                                          style={{
                                            marginBottom: "8px",
                                            padding: "6px 10px",
                                            display: "flex",
                                            alignItems: "center",
                                            borderRadius: "4px",
                                          }}
                                        >
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: option.questionOption,
                                            }}
                                            style={{ flex: 1 }}
                                          />
                                          {el.questionTypeId === 11 ? (
                                            isSelected ? (
                                              <>
                                                <img
                                                  src="/images/correct.svg"
                                                  alt="correct"
                                                  style={{ marginLeft: 6 }}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: 6,
                                                    fontSize: 12,
                                                    color: "green",
                                                  }}
                                                >
                                                  Your Answer
                                                </span>
                                              </>
                                            ) : null
                                          ) : isCorrect ? (
                                            <>
                                              <img
                                                src="/images/correct.svg"
                                                alt="correct"
                                                style={{ marginLeft: 6 }}
                                              />
                                              <span
                                                style={{
                                                  marginLeft: 6,
                                                  fontSize: 12,
                                                  color: "green",
                                                }}
                                              >
                                                Correct Answer
                                              </span>
                                            </>
                                          ) : isSelected && !isCorrect ? (
                                            <>
                                              <img
                                                src="/images/incorrect.svg"
                                                alt="wrong"
                                                style={{ marginLeft: 6 }}
                                              />
                                              <span
                                                style={{
                                                  marginLeft: 6,
                                                  fontSize: 12,
                                                  color: "red",
                                                }}
                                              >
                                                Your Answer
                                              </span>
                                            </>
                                          ) : null}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                  {el.shouldProvideReason === 1 &&
                                    el.reason && <hr />}
                                  {el.shouldProvideReason === 1 &&
                                    el.reason && (
                                      <div className="mt-3 px-2">
                                        <strong>Justification</strong>
                                        <p
                                          style={{
                                            backgroundColor: "#f8f9fa",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "4px",
                                            padding: "8px",
                                            fontSize: "14px",
                                            color: "#333",
                                          }}
                                        >
                                          {el.reason}
                                        </p>
                                      </div>
                                    )}
                                </>
                              ) : (
                                <div>
                                  <textarea
                                    className="form-control"
                                    value={el.answerText}
                                    disabled
                                  />
                                </div>
                              )}
                              {el.reviewStatus === 2 && !isSharedReport && !hideSensitive && (
                                <>
                                  <img
                                    src="/images/edit-icon.svg"
                                    alt="Edit"
                                    style={{
                                      width: 18,
                                      height: 18,
                                      marginLeft: 8,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSelectedQuestion({
                                        ...el,
                                        candidateQuestionId:
                                          el.candidateTestQuestionId,
                                      });
                                      setEditScore(el.answerScore || 0);
                                      setEditComment("");
                                      setShowEditPopup(true);
                                    }}
                                  />
                                  <img
                                    src="/images/comment-icon.svg"
                                    alt="Comments"
                                    style={{
                                      width: 18,
                                      height: 18,
                                      marginLeft: 8,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleViewComments(el)}
                                  />
                                </>
                              )}
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      );
                    })}
                </Accordion>
              </div>
            ) : null}
          </Fragment>
        ) : (
          <div className="test-report-header">
            <div
              className="d-flex justify-content-between"
              style={{ width: "55%" }}
            >
              <img
                src="/images/back-white.svg"
                className="cursor-pointer"
                onClick={() => goBack()}
                alt=""
              />
              <h3>Test Report</h3>
            </div>
            <hr style={{ color: "#fff", border: "1px solid #3D4143" }} />
            <p>
              Something went wrong while report generating. Please check after
              some time
            </p>
          </div>
        )
      ) : (
        <Fragment>
          <div className="test-report-header">
            <div
              className="d-flex justify-content-between"
              style={{ width: "55%" }}
            >
              <img
                src="/images/back-white.svg"
                className="cursor-pointer"
                onClick={() => navigate(-1)}
                alt=""
              />
              <h3>Test Report</h3>
            </div>
          </div>
          <div class="bg-white rounded p-3 mb-3">
            <div class="row hidden-phone">
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Name
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.name}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Email
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.emailId}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Test Name
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.testName}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Date(GMT)
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.testAttemptDate}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Total Scrore
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.scores}
                </label>
              </div>

              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Total Questions
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.totalTestQuestions}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Total Questions Attempts
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.totalQuestionsAttemps}
                </label>
              </div>
              <div class="col-3 form-group">
                {" "}
                <label class="labletext2" style={{ paddingLeft: "5%" }}>
                  Duration
                </label>
              </div>
              <div class="col-3 form-group">
                <label class="label" style={{ paddingTop: 0 }}>
                  {detailReport?.totalTestDuration}
                </label>
              </div>
            </div>
            <div class="row mt-5 visible-phone report-details">
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Name
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 0 }}>
                    {detailReport?.name}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Email
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 0 }}>
                    {detailReport?.emailId}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Test Name
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.testName}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Date(GMT)
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.testAttemptDate}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Total Scrore
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.scores}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Total Questions
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.totalTestQuestions}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Total Questions Attempts
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.totalQuestionsAttemps}
                  </label>
                </div>
              </div>
              <div class="col-12">
                <div class="col-3">
                  {" "}
                  <label class="labletext2" style={{ paddingLeft: "5%" }}>
                    Duration
                  </label>
                </div>
                <div class="col-9">
                  <label class="label" style={{ paddingTop: 10 }}>
                    {detailReport?.totalTestDuration}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
      <Lightbox
        openBox={openBox}
        image={image}
        closeBox={() => setOpenBox(false)}
        showPrev={selectedImageIndex > 0}
        showNext={selectedImageIndex < detailReport?.capturedImages?.length - 1}
        onPrev={() => {
          if (selectedImageIndex > 0) {
            const prevIndex = selectedImageIndex - 1;
            setSelectedImageIndex(prevIndex);
            setImage(detailReport.capturedImages[prevIndex].imageURL);
          }
        }}
        onNext={() => {
          if (selectedImageIndex < detailReport.capturedImages.length - 1) {
            const nextIndex = selectedImageIndex + 1;
            setSelectedImageIndex(nextIndex);
            setImage(detailReport.capturedImages[nextIndex].imageURL);
          }
        }}
      />
      {showEditPopup && (
        <div className="upload-modal">
          <div className="modal-content" style={{ width: isMobile ? "" : "360px" }}>
            <div className="modal-head">
              <div></div>
              <h3>Edit Score</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowEditPopup(false)}
              />
            </div>
            <div
              className="modal-input d-flex flex-column align-items-start"
              style={{ gap: "15px" }}
            >
              <div className="modal-input-label">
                <label>Score :</label>
                <input
                  type="number"
                  min="0"
                  max={selectedQuestion?.score || 0}
                  className="form-control"
                  value={editScore}
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    // Allow empty input for clearing the field
                    if (inputValue === "") {
                      setEditScore("");
                      return;
                    }

                    const value = Number(inputValue);
                    const max = selectedQuestion?.score || 0;

                    // Prevent negative or greater than max
                    if (value >= 0 && value <= max) {
                      setEditScore(value);
                    } else if (value > max) {
                      setEditScore(max);
                    } else {
                      setEditScore(0);
                    }
                  }}
                />
                <p
                  style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}
                >
                  (Allowed range: 0 - {selectedQuestion?.score ?? 0})
                </p>
              </div>
              <div className="modal-input-label">
                <label>Comment :</label>
                <textarea
                  rows="2"
                  className="form-control"
                  value={editComment}
                  onChange={(e) => setEditComment(e.target.value)}
                  style={{ height: "unset" }}
                />
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={handleSaveEdit}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
      {commentPopup && commentsData.length > 0 && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? "" : "420px", maxHeight: "420px" }}
          >
            <div className="modal-head">
              <div></div>
              <h3>Question Comments</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setCommentPopup(false)}
              />
            </div>

            {/* Chat Container */}
            <div className="chat-container">
              {commentsData.map((comment, idx) => {
                const dateObj = new Date(comment.createdAt);
                const formattedTime = dateObj.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
                const formattedDate = dateObj.toLocaleDateString([], {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                });
                const initial =
                  comment.createdByName?.trim()?.charAt(0)?.toUpperCase() ||
                  "?";

                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    {/* Profile Circle */}
                    <div
                      style={{
                        backgroundColor: "#f75891",
                        color: "white",
                        borderRadius: "50%",
                        width: "36px",
                        height: "36px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        flexShrink: 0,
                      }}
                    >
                      {initial}
                    </div>

                    {/* Message Bubble */}
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        maxWidth: "80%",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          marginBottom: "4px",
                          color: "#075E54",
                        }}
                      >
                        {comment.createdByName?.trim()}
                      </p>
                      <p
                        style={{
                          fontSize: "14px",
                          margin: "0 0 4px 0",
                          color: "#000",
                        }}
                      >
                        {comment.commentText}
                      </p>
                      <p
                        style={{
                          fontSize: "11px",
                          textAlign: "right",
                          color: "#555",
                          margin: 0,
                        }}
                      >
                        {formattedDate}, {formattedTime}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {testCommentPopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? "" : "420px", maxHeight: "420px" }}
          >
            <div className="modal-head">
              <div></div>
              <h3>Test Comments</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setTestCommentPopup(false)}
              />
            </div>

            <div
              style={{
                borderBottomLeftRadius: "0",
                borderBottomRightRadius: "0",
              }}
              className="chat-container"
              ref={testChatRef}
            >
              {testComments.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    color: "#666",
                    marginTop: "20px",
                  }}
                >
                  No comments yet
                </div>
              ) : (
                testComments.map((comment, idx) => {
                  const dateObj = new Date(comment.createdAt);
                  const formattedTime = dateObj.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                  const formattedDate = dateObj.toLocaleDateString([], {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  });
                  const initial =
                    comment.createdByName?.trim()?.charAt(0)?.toUpperCase() ||
                    "?";
                  return (
                    <div
                      key={idx}
                      className="chat-message"
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#f75891",
                          color: "white",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          flexShrink: 0,
                        }}
                      >
                        {initial}
                      </div>
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          padding: "8px 12px",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          maxWidth: "80%",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            margin: "0 0 4px",
                            color: "#075E54",
                          }}
                        >
                          {comment.createdByName?.trim()}
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                            margin: "0 0 4px",
                            color: "#000",
                          }}
                        >
                          {comment.commentText}
                        </p>
                        <p
                          style={{
                            fontSize: "11px",
                            textAlign: "right",
                            color: "#555",
                            margin: 0,
                          }}
                        >
                          {formattedDate}, {formattedTime}
                        </p>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* WhatsApp style input bar */}
            <div className="comment-input">
              <input
                type="text"
                value={newCommentText}
                onChange={(e) => setNewCommentText(e.target.value)}
                placeholder="Type a message"
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    await handleSendTestComment();
                  }
                }}
              />

              <button
                onClick={handleSendTestComment}
                disabled={sendingComment || !newCommentText.trim()}
                style={{
                  cursor: newCommentText.trim() ? "pointer" : "not-allowed",
                }}
              >
                {sendingComment ? (
                  <div
                    className="loading-overlay"
                    style={{ alignItems: "center", height: "auto" }}
                  >
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ width: "18px", height: "18px" }}
                    >
                      <span className="visually-hidden">Loading job...</span>
                    </div>
                  </div>
                ) : (
                  <img
                    src="/images/send-icon.svg"
                    alt="Send"
                    style={{ width: 18, height: 18 }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
}
